import reactUniversalComponent from '@nerdwallet/nw-app-module/universal';
export default reactUniversalComponent;